import filaHttpService from '../_services/filaHttpService'

export const cadastroFilasMethods = {
  cancelar() {
    this.$router.push({ name: 'Fila' })
  },
  async salvar() {
    this.form.senhaWeb = this.form.senhaRamal
    this.pararLoader.parar = false

    if (!this.form.announce) {
      this.form.announce = 'no'
    }

    this.$v.$touch()
    if (this.$v.$error) {
      this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
      this.pararLoader.parar = true
      return
    }
    try {
      if (this.edicao === 'true') {
        await filaHttpService.putFila(this._id, this.form)
      } else {
        await filaHttpService.postFila(this.form)
      }
      this.$router.push({ name: 'Fila' })
    } catch (error) {
      let key = Object.keys(error.response.data)
      this.text = error.response.data[key[0]]
      this.snackbar = true
      this.pararLoader.parar = true
    }
  },
}

export const cadastroFilasWatchers = {
  autopause() {
    this.autopause ? (this.form.autopause = 'yes') : (this.form.autopause = 'no')
  },
  ringinuse() {
    this.ringinuse ? (this.form.ringinuse = 'yes') : (this.form.ringinuse = 'no')
  },
  announceHoldTime() {
    this.announceHoldTime ? (this.form.announceHoldTime = 'yes') : (this.form.announceHoldTime = 'no')
  },
  reportholdtime() {
    this.reportholdtime ? (this.form.reportholdtime = 'yes') : (this.form.reportholdtime = 'no')
  },
  randomPeriodicAnnounce() {
    this.randomPeriodicAnnounce ? (this.form.randomPeriodicAnnounce = 'yes') : (this.form.randomPeriodicAnnounce = 'no')
  },
}
